module.exports = __webpack_public_path__ + "img/agricola.6a3bb776.svg";